import { createSelector } from 'reselect';
import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

const selectSavedFilterViews = (state) => get(state, 'savedFilterViews', emptyArray);
const selectCustomFilterView = (state) => get(state, 'customFilterView');
const selectDefaultFilterView = (state) => get(state, 'defaultFilterView');

export const selectActiveFilterViewId = (state) => get(state, 'activeFilterViewId');

export const selectActiveFilterView = createSelector(
  selectActiveFilterViewId,
  selectDefaultFilterView,
  selectCustomFilterView,
  selectSavedFilterViews,
  (activeFilterViewId, defaultFilterView, customFilterView, savedFilterViews) => {
    const allViews = [...savedFilterViews, defaultFilterView];

    if (customFilterView) {
      allViews.push(customFilterView);
    }

    return allViews.find((view) => view.filterViewId === activeFilterViewId);
  },
);
